import styled from "styled-components/macro";

export const ContainerIdiom = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 1.5rem;
  top: 2rem;
  z-index: 999;
  @media (min-width: 992px) {
    display: none;
  }
`;
export const ContainerIdiomView = styled.div`
  z-index: 999999;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: 0 1rem;
  position: absolute;
  overflow: hidden;
  left: 0;
  top: 1.2rem;
  width: 40px;
  background: #ffffff;
  border-radius: 4px;

  transition: max-height 0.6s, opacity 1s;
  max-height: ${({ modalFlag }) => (modalFlag ? "300px " : "0")};
`;
export const Country = styled.p`
  margin: 0.2rem 0 0.2rem 0;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 13px;
  color: #f5f5f5;
  padding-left: 1rem;
  @media (min-width: 992px) {
    font-weight: 300;
    font-size: 12px;
    line-height: 19px;
  }
`;
export const CountryModal = styled.p`
  margin: 0.5rem 0;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 13px;
  color: #3c003d;
  text-align: start;
  @media (min-width: 992px) {
  }
`;
export const Svg = styled.svg`
  padding-top: 0.3rem;
  padding-left: 0.3rem;
  width: 16px;
  height: 9px;
  transition: transform 0.8s ease-in-out;
  transform: ${({ modalFlag }) =>
    modalFlag ? "rotate(-180deg) translate(-5px,-5px)" : "rotate(0)"};

  @media (min-width: 992px) {
  }
`;
export const Path = styled.path`
  stroke: #f5f5f5;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;
  padding-top: 6rem;

  h1 {
    margin: 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 47px;
    color: #ffffff;
    text-align: center;
    padding: 0 2rem;
    margin-bottom: 2rem;
  }
  h3 {
    margin: 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 3rem;
  }

  p {
    margin: 0;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #ffffff;
    text-align: center;
    padding: 0 2rem;
    margin-bottom: 1rem;
  }
  @media (min-width: 992px) {
    h3 {
      display: none;
    }
    h1 {
      font-size: 48px;
      line-height: 47px;
      margin-bottom: 2.5rem;
    }
    p {
      font-size: 16px;
      line-height: 27px;
      padding: 0 22rem;
      margin-bottom: 2rem;
    }
  }
`;
export const ContainerButton = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: center;
    padding: 0 30.5rem;
  }
`;

export const Button = styled.a`
  text-decoration: none;
  cursor: pointer;
  z-index: 10;
  width: 192px;
  height: 41px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 18px;
  text-decoration: none;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
  color: #f7f7f7;
  padding: 0.5rem 0.3rem 0.3rem 0.3rem;
  margin-bottom: 2rem;
  &:focus {
    background: #ffffff;
    color: #a71b38;
  }

  @media (min-width: 992px) {
    cursor: pointer;
    width: 200px;
    height: 37px;
    margin: 0;
    font-size: 16px;
    border: 1px solid #ffffff;
    z-index: 999;
    &:focus {
      z-index: 999;
      border: 1px solid #ffffff;
      background: #ffffff;
      color: #a71b38;
    }
  }
`;
export const ButtonIdiomDeskt = styled.button`
  cursor: pointer;
  z-index: 999;
  width: 192px;
  height: 41px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 18px;
  text-decoration: none;
  text-align: center;
  font-family: "Rubik", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  background: transparent;
  color: #f7f7f7;
  padding: 0.3rem;
  margin-bottom: 2rem;
  &:focus {
    background: #ffffff;
    color: #a71b38;
  }
  @media (min-width: 992px) {
    cursor: pointer;
    width: 3.5rem;
    height: 30px;
    margin: 0 0.3rem;
    font-size: 16px;
    border: ${({ uk, bra, esp }) =>
      uk || bra || esp ? "1px solid #ffffff" : "none"};
    &:focus {
      border: 1px solid #ffffff;
      background: transparent;
      color: #ffffff;
    }
  }
`;
export const ContainerMenu = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 1.4rem;
    left: 25rem;
    a {
      font-family: "Rubik";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #ffffff;
      text-align: center;
      margin: 0 2rem;
      cursor: pointer;
      text-decoration: none;
    }
  }
`;
export const ContainerIdiomDesktop = styled.div`
  display: none;
  @media (min-width: 992px) {
    z-index: 999;
    display: block;
    position: absolute;
    right: 6.5rem;
    top: 1rem;
  }
`;
export const ButtonBurguer = styled.button`
  background-color: transparent;
  border: none;
  padding: 1rem 0 0 1rem;
  text-decoration: none;
  &:focus {
    text-decoration: none;
  }
  @media (min-width: 992px) {
    display: none;
  }
`;
export const ContainerNavBarFixed = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: block;
    position: fixed;
    width: 100%;
    height: 3.5rem;
    background-color: ${({ scroll }) =>
      scroll > 100 ? "rgba(0,0,0,0.7)" : "transparent"};
    /* backdrop-filter: blur(2px); */
    z-index: 999;
    transition: background-color 0.5s ease-in-out;
  }
`;
export const TextProde = styled.h3`
  position: absolute;
  top: 1rem;
  left: 7.7rem;
  margin: 0;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #ffffff;
  text-align: center;
  animation-name: animar;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-direction: alternate;
  @keyframes animar {
    from {
      transform: translateX(-500px);
    }

    to {
      transform: translateX(0);
    }
  }
`;
